import { getCurrentAuthState } from '~/atoms/AuthenticationState'
import { getUserFromToken } from '~/utils/auth'
import { getApiEnvironment } from '~/utils/common'

import { Pbx } from '@mangovoice/types'

const LEGACY_STORAGE_KEY = 'recent-pbxs'
const MAX_RECENTS = 10

interface RecentPbxEntry {
  id: number
  name: string
  lastUsed: number
}

// PBX ids are only valid for the API environment and user they came from
function getStorageKey(): string | undefined {
  const userId = getUserFromToken(
    getCurrentAuthState().appSessionJwts?.access_token,
  )?.id
  if (!userId) return undefined
  return `${LEGACY_STORAGE_KEY}:${getApiEnvironment()}:${userId}`
}

function getRecents(): RecentPbxEntry[] {
  try {
    const storageKey = getStorageKey()
    if (!storageKey) return []
    // The unscoped list can't be attributed to an environment or user
    localStorage.removeItem(LEGACY_STORAGE_KEY)
    const raw = localStorage.getItem(storageKey)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function saveRecents(entries: RecentPbxEntry[]) {
  const storageKey = getStorageKey()
  if (!storageKey) return
  localStorage.setItem(storageKey, JSON.stringify(entries))
}

export function getRecentPbxs(): RecentPbxEntry[] {
  return getRecents().sort((a, b) => b.lastUsed - a.lastUsed)
}

export function addRecentPbx(pbx: Pick<Pbx, 'id' | 'name'>) {
  const recents = getRecents().filter((r) => r.id !== pbx.id)
  recents.unshift({ id: pbx.id, name: pbx.name, lastUsed: Date.now() })
  saveRecents(recents.slice(0, MAX_RECENTS))
}

export function removeRecentPbx(pbxId: number) {
  saveRecents(getRecents().filter((r) => r.id !== pbxId))
}
